import { Alert, CircularProgress, Stack, Typography } from "@mui/material";
import { HttpError } from "components/ServerValidationErrors";
import { ImportResults } from "domains/stock-transfer-imports/components/file-import-results";
import { useGetStockTransferFileImportResults } from "domains/stock-transfer-imports/services/use-stock-transfer-import-api";
import RootPage from "pages/RootPage";
import { useParams } from "react-router-dom";

function ImportHistoricResultsSandboxPage() {
    const { id } = useParams<{ id: guid }>();
    const { data, error, loading } = useGetStockTransferFileImportResults(id);

    const notFoundError = error && (error instanceof HttpError) && (error as HttpError).status === 404;

    return <RootPage header="Previous Import Results">
               <Stack spacing={4}>
                    <Typography variant="h5">Results</Typography>
                   {data && <Alert severity={data.outcome === "Succeeded" ? "info" : "warning"}>
                              <Typography>Request ID: {id}</Typography>
                              <Typography>Outcome: {data.outcome}</Typography>
                            </Alert>}
                   {loading && <CircularProgress aria-busy="true" />}
                   {data && <ImportResults
                               requestErrors={data?.requestErrors}
                               itemErrors={data?.requestItemErrors}
                               itemActions={data?.requestItemActions}
                           />}
                   {error && <Alert color="error">{notFoundError ? "Request not found!" : error.toString()}</Alert>}
               </Stack>
           </RootPage>;
}

export default ImportHistoricResultsSandboxPage;